<template>
  <v-container style="padding: 0;">
    <v-row wrap style="padding: 0; margin-bottom: -14px">
      <v-col cols="12" style="padding: 0">
        <vue-web-cam
          ref="webcam"
          :class="{invisible: !displayCam}"
          style="margin: 0; height: 400px; width: 100%; top: 42px; position: absolute; left: 0; z-index: 80;"
          :resolution="{width: 640, height: 480}"
          :device-id="deviceId"
          selectFirstDevice
          width="100%"
          @error="onError"
          @camera-change="onCameraChange"
        />

        <v-img
          id="sentImage"
          :class=" {invisible: displayCam}"
          style=" height: 400px; width: 100%; z-index: 90; margin-top: 20px"
          :loading="true"
          :src="img"
        >
          <div
            id="equipement"
            style="border: 3px solid red; border-radius: 4px; position: absolute; top: -10px; left: -10px; z-index: 890;"
          />
          <div
            id="face"
            style="border: 3px solid lime; border-radius: 4px; position: absolute; top: -10px; left: -10px; z-index: 900"
          />
        </v-img>
      </v-col>

      <!-- O botão só aparece se momento for diferente de 1 -->
      <v-btn
        v-if="momento !== 1"
        block
        color="primary"
        style="background: #4488ff; z-index: 120; border-radius: 0 0 4px 4px;"
        :loading="startLoad"
        @click="onCapture"
      >
        Capturar Imagem
      </v-btn>
    </v-row>
  </v-container>
</template>
<script>
import { WebCam } from "vue-web-cam";
export default {
    name: "CamImage",
    components: {
      "vue-web-cam": WebCam
    },
    props: {
      title: {
        type: String,
        required: false,
      },
      randomGesture: {
        type: String,
        required: false,
      },
      momento: {
        type: Number,
        required: true,
      },
    },
    data() {
        return {
            startLoad: true,
            img: null,
            camera: null,
            deviceId: null,
            displayCam: true,
            devices: [],
            isCapturing: false,
        };
    },
    computed: {
      device: function() {
        return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },
    watch: {
      camera: function(id) {
        this.deviceId = id;
        },
    },
    mounted() {
        this.unsetLoad(1.5);

        document.addEventListener('displayCam', () => {
          this.displayCam = !this.displayCam;
        });

        if (!this.captureEventListenerAdded) {
          document.addEventListener('onCapture', () => {
            this.onCapture();
          });
          this.captureEventListenerAdded = true;
      }

    },
    methods: {
        clearEquipement() {
            let box = document.getElementById("equipement");
            box.style.top = "-10px";
            box.style.left = "-10px";
            box.style.height = "0px";
            box.style.width = "0px";
        },
        clearFace() {
            let box = document.getElementById("face");
            box.style.top = "-10px";
            box.style.left = "-10px";
            box.style.height = "0px";
            box.style.width = "0px";
        },
        unload() {
            this.startLoad = false;
        },
        onCapture() {
          if (this.isCapturing) return; 
            this.isCapturing = true; 
            this.startLoad = true;
            this.unsetLoad(3.5);
            this.clearEquipement();
            this.clearFace();
            const timeoutDuration = this.momento == 1 ? 10000 : 5000;
            setTimeout(() => {
              this.img = this.$refs.webcam.capture();
              this.$emit('onCapture', this.img);
              this.$emit('updateInfo', this.img);
              this.displayCam = false;
              this.isCapturing = false;
    }, timeoutDuration);
      },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
        },
      unsetLoad(seconds = 1.5) {
        setTimeout(
          () => {
            this.startLoad = false;
          },
          seconds * 1000
        );
      }
    }
};
</script>

<style>
  .invisible{
    opacity: 0;
  }
</style>
